import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent {
  readonly id = input<string>();
  readonly value = input<any>();
  readonly text = input<string>();
  readonly description = input<string>();
  readonly checked = input<boolean>();
  readonly onChange = output<any>();
  readonly disabled = input<boolean>(false);
}
